import React, { FunctionComponent, ReactElement } from 'react';
import { Box } from '@material-ui/core';
import { GetVariants_trimLevelVariants_variants } from '../../../../../../gqlCommon/graphql/__generated__/GetVariants';
import VariantSelectorItemContainer from '../variantSelectorItem/VariantSelectorItemContainer';

export interface IVariantListProps {
  variants: GetVariants_trimLevelVariants_variants[];
  model: string;
  selectedVariantId: string;
  selectVariantId: (variantId: string) => void;
  detailsSlot?: ReactElement;
}

const VariantList: FunctionComponent<IVariantListProps> = ({
  variants,
  model,
  selectedVariantId,
  selectVariantId,
  detailsSlot,
}) => {
  return (
    <Box data-test={'variant:list'} width={1}>
      {variants?.map((item, id) => (
        <Box
          key={id}
          data-test={`variant:selector:${item.variant.code}`}
          data-selected={selectedVariantId === item.variant.code}
        >
          <VariantSelectorItemContainer
            modelName={model}
            variantName={item.variant.attributes.name}
            selected={selectedVariantId === item.variant.code}
            id={item.variant.code}
            selectVariantId={selectVariantId}
            detailsSlot={detailsSlot}
          />
        </Box>
      ))}
    </Box>
  );
};

export default VariantList;
